import { useFyaiConfig } from "@/hooks/useFyaiConfig";
import { fyaiPlatforms } from "@/mocks/fyai-data";

export default function FyaiDownloadTip() {
  const config = useFyaiConfig();

  return (
    <section id="download-tip" className="w-full bg-primary-950 px-4 py-14 md:px-6 md:py-16">
      <div className="flex flex-col items-start justify-between gap-8 lg:flex-row lg:items-center">
        <div className="max-w-2xl">
          <h2 className="font-heading text-2xl font-bold text-background-50 md:text-3xl">
            风月AI官网下载
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-primary-200 md:text-base">
            请认准官方域名，避免下载到非官方版本。风月AI聊天软件支持 Android、iOS、HarmonyOS、Windows 四大平台。
          </p>
        </div>
        <div className="flex flex-wrap items-center gap-3">
          <span className="rounded-md border border-accent-500/40 bg-primary-900/60 px-4 py-3 font-heading text-base font-bold text-accent-400 md:text-lg">
            {config.domain}
          </span>
          {fyaiPlatforms.map((platform) => (
            <span
              key={platform.key}
              className="inline-flex items-center gap-1.5 rounded-full bg-primary-900/60 px-3 py-1.5 text-xs font-medium text-primary-100"
            >
              <i className={platform.icon} />
              {platform.name}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}